<app-users-listing [enableMainBtn]="true" [titleMainBtn]="'Aggiungi Studente'" [type]="type"
  [linkMainBtn]="'/nuovo-utente'" [linkMainBtnQueryParams]="{type: type}">
</app-users-listing>